import { useMemo, JSX } from 'react'

import { SelectInput, SelectOption } from '~/components/component-library'
import { AddressDisplay } from '~/components/component-library/AddressDisplay'
import { useActiveOrg } from '~/hooks/org'
import { IAddress } from '~/types'

export const ExternalAccountSelectInput = ({
  label,
  selectedOption,
  emptyText,
  setValue,
  isDisabled = false,
}: {
  label: string
  selectedOption: IAddress | undefined
  emptyText: string
  setValue: (value: IAddress) => void
  isDisabled?: boolean
}): JSX.Element => {
  const { org } = useActiveOrg()

  const options: SelectOption<IAddress>[] = useMemo(() => {
    return (
      org?.bridge?.externalAccounts.map(({ liquidationAddress }) => ({
        value: liquidationAddress,
        label: (
          <AddressDisplay
            address={liquidationAddress}
            layout="standard"
            isInternal
            hidePopover
          />
        ),
      })) ?? []
    )
  }, [org])

  return (
    <SelectInput<IAddress>
      label={label}
      options={options}
      selectedOption={selectedOption}
      selectValue={setValue}
      placeholder={emptyText}
      disabled={isDisabled}
    />
  )
}
